import { render, staticRenderFns } from "./TJ-Modal.vue?vue&type=template&id=5778b08d&scoped=true&"
import script from "./TJ-Modal.vue?vue&type=script&lang=js&"
export * from "./TJ-Modal.vue?vue&type=script&lang=js&"
import style0 from "./TJ-Modal.vue?vue&type=style&index=0&id=5778b08d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778b08d",
  null
  
)

export default component.exports